import * as React from 'react'
import { BLUE } from '../../colors'

const IconArchive = (props) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g fill={props.color || BLUE} fillRule='evenodd'>
      <path d='M3 21h18V7H3v14zM7.351 3h9.298l2.5 2H4.851l2.5-2zM22.99 5.953a.98.98 0 0 0-.059-.294c-.014-.038-.031-.071-.049-.106a.97.97 0 0 0-.132-.197c-.027-.031-.052-.062-.083-.09-.016-.014-.025-.033-.042-.047l-5-4A1.001 1.001 0 0 0 17 1H7c-.227 0-.447.077-.625.219l-5 4c-.017.014-.026.033-.042.047-.031.028-.056.059-.083.09a.97.97 0 0 0-.132.197c-.018.035-.035.068-.049.106a.98.98 0 0 0-.059.294C1.009 5.969 1 5.983 1 6v16a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6c0-.017-.009-.031-.01-.047z' />
      <path d='M15.63 14H14v-4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v4H8.369c-.893 0-1.338 1.082-.703 1.711l3.63 3.593c.39.385 1.018.385 1.407 0l3.63-3.593c.635-.629.19-1.711-.703-1.711' />
    </g>
  </svg>
)

export default IconArchive
